import React from "react";
import "./Blogfront.css";

const ReadBlogFront = () => {
  return (
    <div>
      <div className="blog-front">
        <div className="blog-front-content">
          Managing BizTalk Server – Step by Step implementation of IDE-Cloud
          <div className="read-blog-subtitle">
            By Christini | Posted : March 22,2020 | Tags: Biztalk server
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadBlogFront;
